mutation UpdatePromocode($id: ID!, $input: UpdatePromocodeInput!) {
  updatePromocode(id: $id, input: $input) {
    id
    title
    createdAt
    updatedAt
  }
}
